export enum AccountingMethodsEnum {
  Unknown = 0,
  Cash = 1,
  Accrual = 2
}
